import { z } from "zod";

const envSchema = z.object({
  APP_ENV: z.enum([
    "development",
    "stage",
    "prod",
    "e2e",
    "test",
    "test2",
    "test3",
    "test4",
    "test5",
    "development-remote",
  ]),
  AUTH_AUTHORITY: z.string().min(1),
  AUTH_CLIENT_ID: z.string().min(1),
  API_URL: z.string().min(1),
  ACCOUNT_SETTINGS_URL: z.string().min(1),
});

const envConfig = {
  APP_ENV: import.meta.env.MODE,
  AUTH_AUTHORITY: import.meta.env.VITE_AUTH_AUTHORITY,
  AUTH_CLIENT_ID: import.meta.env.VITE_AUTH_CLIENT_ID,
  API_URL: import.meta.env.VITE_API_URL,
  ACCOUNT_SETTINGS_URL: import.meta.env.VITE_ACCOUNT_SETTINGS_URL,
} as const;

if (envConfig.APP_ENV !== "prod") {
  // eslint-disable-next-line no-console
  console.log(`Environment configuration: ${JSON.stringify(envConfig)}`);
}

export const appConfig = {
  /** https://vite.dev/guide/env-and-mode.html#env-variables */
  env: envSchema.parse(envConfig),
  /** https://mui.com/x/introduction/licensing/ */
  MUI_X_LICENSE_KEY:
    "14b5c42b61936f944fbfe79545fe216cTz0xMjY4NTIsRT0xODA0OTgyMzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTIsQVQ9bXVsdGksS1Y9Mg==",
  BOOK_DEMO_URL: {
    no: "https://draftit.no/personvern/leverandorevaluering",
    se: "https://draftit.se/dataskydd/leverant%C3%B6rsutv%C3%A4rdering",
  },
} as const;
